/*
 * AI-MOD: BH-RECENT-LOCALE-001
 * Purpose: Fetch Recently Viewed product JSON and links in the active Shopify locale.
 * Scope: Product pages using Impulse theme.RecentlyViewed and theme-recent storage.
 * No-JS fallback: The Recently Viewed carousel is an optional JavaScript component.
 * Remove: Delete this asset and its loader in layout/theme.liquid. See AI-MODIFICATIONS.md.
 */
(function () {
  'use strict';

  var setupAttempts = 0;

  function setupLocaleAwareHistory() {
    if (!window.theme || !theme.RecentlyViewed || !theme.recentlyViewed) {
      setupAttempts += 1;

      if (setupAttempts < 40) {
        window.setTimeout(setupLocaleAwareHistory, 50);
      }

      return;
    }

  var prototype = theme.RecentlyViewed.prototype;

  if (prototype.__biohansaLocaleAware) {
    return;
  }

  var localeRoot =
    (theme.routes && theme.routes.home) ||
    (window.Shopify && Shopify.routes && Shopify.routes.root) ||
    '/';

  if (localeRoot.charAt(localeRoot.length - 1) !== '/') {
    localeRoot += '/';
  }

  var localeCode = (document.documentElement.lang || 'fi')
    .toLowerCase()
    .split('-')[0];
  var localeStorageKey = 'theme-recent-' + localeCode;

  function productEndpoint(handle) {
    return localeRoot + 'products/' + encodeURIComponent(handle);
  }

  function saveRecentProducts() {
    if (!theme.config.hasLocalStorage) {
      return;
    }

    window.localStorage.setItem(
      'theme-recent',
      JSON.stringify(theme.recentlyViewed.recent)
    );
    window.localStorage.setItem(
      localeStorageKey,
      JSON.stringify(theme.recentlyViewed.recent)
    );
  }

  function readStoredProducts(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '{}');
    } catch (error) {
      return {};
    }
  }

  function addCurrentProduct(localeProducts) {
    var productSection = document.querySelector(
      '.product-section[data-product-handle][data-product-url]'
    );

    if (!productSection) {
      return localeProducts;
    }

    var handle = productSection.getAttribute('data-product-handle');

    if (!handle) {
      return localeProducts;
    }

    delete localeProducts[handle];
    localeProducts[handle] = {
      url: productEndpoint(handle),
      aspectRatio: productSection.getAttribute('data-aspect-ratio'),
      featuredImage: productSection.getAttribute('data-img-url')
    };

    return localeProducts;
  }

  // Keep independent histories per storefront language. This intentionally does
  // not migrate Finnish handles into ET/EN because translated handles can differ.
  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.recent = addCurrentProduct(
      readStoredProducts(localeStorageKey)
    );
    saveRecentProducts();
  }

  // Impulse's session cache is shared across languages. Ignore the old cache so
  // a locale change cannot reuse a Finnish title in Estonian or English.
  theme.recentlyViewed.productInfo = {};
  if (theme.config.hasSessionStorage) {
    window.sessionStorage.removeItem('recent-products');
  }

  prototype.getProductInfo = function (storedHandle) {
    return fetch(productEndpoint(storedHandle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recently Viewed product request failed');
        }
        return response.text();
      })
      .then(function (productJson) {
        var product = JSON.parse(productJson);
        var storedProduct = theme.recentlyViewed.recent[storedHandle] || {};

        if (!product.handle) {
          return null;
        }

        theme.recentlyViewed.recent[product.handle] = {
          url: productEndpoint(product.handle),
          aspectRatio: storedProduct.aspectRatio,
          featuredImage: storedProduct.featuredImage
        };
        saveRecentProducts();

        return productJson;
      })
      .catch(function () {
        return null;
      });
  };

  if (theme.Product && theme.Product.prototype.addIdToRecentlyViewed) {
    var originalAddId = theme.Product.prototype.addIdToRecentlyViewed;

    theme.Product.prototype.addIdToRecentlyViewed = function () {
      originalAddId.call(this);
      saveRecentProducts();
    };
  }

    prototype.__biohansaLocaleAware = true;
  }

  setupLocaleAwareHistory();
})();
